import { render, staticRenderFns } from "./KeyReview.vue?vue&type=template&id=84ea3b00&"
import script from "./KeyReview.vue?vue&type=script&lang=js&"
export * from "./KeyReview.vue?vue&type=script&lang=js&"
import style0 from "./KeyReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KeyReview.vue"
export default component.exports